const capabilities = [
  {
    index: '01',
    title: 'Architecture',
    description: 'Designing modular, clean architectures that separate concerns and enable long-term maintainability across complex systems.',
  },
  {
    index: '02',
    title: 'Performance',
    description: 'Building high-performance systems optimized at every layer for speed, efficiency, and responsive user experiences.',
  },
  {
    index: '03',
    title: 'Usability',
    description: 'Crafting intuitive, user-centered interfaces that prioritize clarity, accessibility, and seamless interaction.',
  },
  {
    index: '04',
    title: 'Quality',
    description: 'Ensuring stability and reliability through rigorous engineering standards and continuous improvement practices.',
  },
];

export default function CapabilitiesSection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-32 px-6 md:px-12">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Core Capabilities
          </h2>
          <p className="text-base text-foreground-500 font-body mt-3 md:mt-0">
            What we bring to every project
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {capabilities.map((cap) => (
            <div
              key={cap.index}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-8 flex flex-col"
            >
              <p className="text-7xl font-bold font-heading text-background-200 leading-none select-none">
                {cap.index}
              </p>
              <h3 className="text-lg font-semibold font-heading text-foreground-950 mt-6">
                {cap.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600 font-body mt-3">
                {cap.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}